var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3714_54197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.00002,
    cy: 8.44765,
    r: 5.56679,
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7436 8.07324H14.3686V8.82324H14.7436V8.07324ZM15.5692 8.82324C15.7763 8.82324 15.9442 8.65535 15.9442 8.44824C15.9442 8.24114 15.7763 8.07324 15.5692 8.07324V8.82324ZM14.7436 8.82324H15.5692V8.07324H14.7436V8.82324Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25698 8.07275H1.63198V8.82275H1.25698V8.07275ZM0.431439 8.82275C0.224332 8.82275 0.0564389 8.65486 0.0564389 8.44775C0.0564389 8.24065 0.224332 8.07275 0.431439 8.07275V8.82275ZM1.25698 8.82275H0.431439V8.07275H1.25698V8.82275Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.375 15.1904L8.375 14.8154L7.625 14.8154L7.625 15.1904L8.375 15.1904ZM7.625 16.0159C7.625 16.2231 7.79289 16.3909 8 16.3909C8.20711 16.3909 8.375 16.2231 8.375 16.0159L7.625 16.0159ZM7.625 15.1904L7.625 16.0159L8.375 16.0159L8.375 15.1904L7.625 15.1904Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.375 1.70265L8.375 2.07765L7.625 2.07765L7.625 1.70265L8.375 1.70265ZM7.625 0.877118C7.625 0.670011 7.79289 0.502118 8 0.502118C8.20711 0.502118 8.375 0.670011 8.375 0.877118L7.625 0.877118ZM7.625 1.70265L7.625 0.877118L8.375 0.877118L8.375 1.70265L7.625 1.70265Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00002,
    cy: 8.44692,
    r: 4.0519,
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02178 5.58544L5.97251 10.1963L8.02178 9.13221L10.071 10.1963L8.02178 5.58544Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3714_54197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerOutline);
export default __webpack_public_path__ + "static/media/tracker-outline.d584da044b0b72fb7c4b8c6953797354.svg";
export { ForwardRef as ReactComponent };